import { ICalculation } from "../../../../models/Lead";
import PriceFormat from "../../../../utils/priceFormat";

const StatusRow = ({ label, value, classes }: { label: string; value: string; classes: string }) => (
  <div className="py-2 grid grid-cols-2 gap-4">
    <dt className="text-sm font-medium text-gray-500">{label}</dt>
    <dd className={`items-center text-sm ${classes}`}>
      <div>{value}</div>
    </dd>
  </div>
);

const CalculationStatusRow = ({ calculation }: { calculation: ICalculation }) => {
  if (!calculation) return null;

  const { name, isFixed, value, baseValue, isAddition, customCalculation } = calculation;
  if (value == null && !customCalculation) return null;

  const output = customCalculation
    ? customCalculation
    : !isFixed
      ? `${value}% of ${PriceFormat(baseValue)} (${PriceFormat((baseValue * value) / 100)})`
      : PriceFormat(value);

  return (
    <div className="py-2 grid grid-cols-2 gap-4">
      <dt className="text-sm font-medium text-gray-500">{name}</dt>
      <dd className={`items-center text-sm ${isAddition ? "" : "text-red-600"}`}>
        <div>{customCalculation ? output : `${isAddition ? "+" : "-"} ${output}`}</div>
      </dd>
    </div>
  );
};

export default function QuoteCalculationBreakdown({
  calculations,
  isCollection,
  dropOff,
  total,
}: {
  calculations: ICalculation[];
  isCollection: boolean;
  dropOff?: number;
  total: number | null;
}) {
  return (
    <>
      {calculations.length === 0 && (
        <p className="py-2 text-sm text-gray-500">No calculation rows available for this selection.</p>
      )}
      {calculations.map((calculation, index) => (
        <CalculationStatusRow key={`${calculation.name}-${index}`} calculation={calculation} />
      ))}
      {!isCollection && dropOff !== undefined && dropOff !== 0 && (
        <StatusRow label="Drop Off" value={PriceFormat(dropOff)} classes="text-gray-900" />
      )}
      <hr />
      <StatusRow
        label="Total"
        value={total === null ? "N/A" : PriceFormat(total)}
        classes="font-medium text-gray-900"
      />
    </>
  );
}
